import { render } from "./Heteroatoms.vue?vue&type=template&id=fc6c7d9c"
import script from "./Heteroatoms.vue?vue&type=script&lang=js"
export * from "./Heteroatoms.vue?vue&type=script&lang=js"
script.render = render

export default script